// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  height: 100%;
  background: var(--color-background);
}
.app .app-content {
  display: grid;
  grid-template-columns: 60px 1fr;
  grid-template-rows: 100%;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  height: calc(100% - 35px);
}
.app .app-content .content-footer {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 100px;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  width: 100%;
}
@media (max-width: 599px) {
  .app .app-content {
    grid-template-columns: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/app/app.scss","webpack://./src/theme/responsiv.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,mCAAA;AADF;AAGE;EACE,aAAA;EACA,+BAAA;EACA,wBAAA;EACA,oBAAA;EACA,iBAAA;EACA,yBAAA;AADJ;AAGI;EACE,aAAA;EACA,0BAAA;EACA,6BAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;AADN;ACjBI;EDuBA;IACE,sCAAA;EAHJ;AACF","sourcesContent":["@import '../../theme/responsiv.scss';\n\n.app {\n  height: 100%;\n  background: var(--color-background);\n\n  .app-content {\n    display: grid;\n    grid-template-columns: 60px 1fr;\n    grid-template-rows: 100%;\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    height: calc(100% - 35px);\n\n    .content-footer {\n      display: grid;\n      grid-template-columns: 1fr;\n      grid-template-rows: 1fr 100px;\n      grid-column-gap: 0px;\n      grid-row-gap: 0px;\n      width: 100%;\n    }\n  }\n\n  @include appSize(phone-only) {    \n    .app-content {\n      grid-template-columns: 100% !important;\n    }\n  }\n}","@mixin appSize($size) {\n  @if $size == phone-only {\n    @media (max-width: 599px) { @content; }\n  } @else if $size == tablet-portrait-up {\n    @media (min-width: 600px) { @content; }\n  } @else if $size == tablet-landscape-up {\n    @media (min-width: 900px) { @content; }\n  } @else if $size == desktop-up {\n    @media (min-width: 1200px) { @content; }\n  } @else if $size == big-desktop-up {\n    @media (min-width: 1800px) { @content; }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
